import { HttpClient } from "@angular/common/http";
import {EventEmitter, Inject, Injectable} from "@angular/core";
import { Router } from "@angular/router";
import { LocalStorageService } from "ngx-webstorage";

@Injectable({
    providedIn: 'root'
})
export class InstallationService {

    private _serverUrl: string = null;
    public installationIdReady: EventEmitter<void> = new EventEmitter<void>();

    constructor(
        @Inject('environment') private _environment: any,
        private _http: HttpClient,
        private _localStorage: LocalStorageService,
    ) {

        this._serverUrl = `${this._environment.baseServerUrl}/rest/installation`;
    }

    public createInstallationIfNotExists(forceCreate: boolean = false, reload?: boolean): void {
        if (!this._localStorage.retrieve('installation_id') || forceCreate) {

            this._http.post(this._environment.baseServerUrl + "/rest/installation", {
                type: "web" ,
                appName: this._environment.application,
                identifier: `com.revotech.${this._environment.application}`
            }, {
                headers: {
                    skip: 'true'
                }
            }).subscribe((res: any) => {
                if (res.installationId) {

                    this._localStorage.store('installation_id', res.installationId);
                    this.installationIdReady.emit();
                    if (reload) {
                        window.location.reload();
                    }
                }
            });

        }
    }

}
